var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"main"},[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}})],1),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('B_Table')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }